import { Fragment, useRef, useState, useEffect } from 'react';
import { Dialog, Transition } from '@headlessui/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { solid } from '@fortawesome/fontawesome-svg-core/import.macro';
// import { blockNumber } from '../api/blockRequest';
import { useNavigate } from 'react-router-dom';
import { Toaster, ToastIcon, toast, resolveValue } from 'react-hot-toast';
import { sendSMS } from '../api/customerRequest';
import { fetchMessage } from '../api/dropdown';
let technicals = [];
let messagesT = [];

const TailwindToaster = () => {
  return (
    <Toaster>
      {(t) => (
        <Transition
          appear
          show={t.visible}
          className='transform p-4 flex bg-white rounded shadow-lg'
          enter='transition-all duration-150'
          enterFrom='opacity-0 scale-50'
          enterTo='opacity-100 scale-100'
          leave='transition-all duration-150'
          leaveFrom='opacity-100 scale-100'
          leaveTo='opacity-0 scale-75'
        >
          <ToastIcon toast={t} />
          <p className='px-2'>{resolveValue(t.message)}</p>
        </Transition>
      )}
    </Toaster>
  );
};
const SubmitModalCustomer = ({
  open,
  setOpen,
  phoneNumber,
  setError,
  setDone,
  technical,
}) => {
  // const userLogin = useSelector((state) => state.userLogin);
  // const { userInfo } = userLogin;
  let navigate = useNavigate();
  useEffect(() => {
    technicals = [technical?.phone1, technical?.phone2];
  }, [technical]);
  const cancelButtonRef = useRef(null);
  const [message, setMessage] = useState('');

  useEffect(() => {
    async function fetchMes() {
      const messagesRes = await fetchMessage('رسالة نصية للزبون');
      if (messagesRes?.data?.success) {
        messagesT = messagesRes?.data?.data;
        setMessage(
          messagesT[0]?.content
            .replace('{technical.phone1}', technical?.phone1)
            .replace('{technical.phone2}', technical?.phone2 || '')
        );
      }
    }
    fetchMes();
  }, [technical]);

  const blockHandler = () => {
    // if (token) {
    // blockNumber(number, reason, token)
    //   .then((res) => {
    sendSMS(message, phoneNumber)
      .then((res) => {
        if (res.success) {
          setError('');
          toast.success('تم إرسال طلبك بنجاح');
          setTimeout(() => {
            setDone(true);
            setOpen(false);
          }, 2000);
        }
      })
      .catch((err) => {
        setError(err.response.data.error);
        toast.error(err.response.data.error);
      });

    // else {
    //   setError(res.error);
    //   setOpen(false);
    //   setNumber('');
    // }
    // })
    // .catch((err) => setError(err));
    // } else {
    //   navigate('/login');
    // }
  };

  return (
    <Transition.Root show={open} as={Fragment}>
      <Dialog
        as='div'
        className='fixed z-40 inset-0 overflow-y-auto font-MyFont'
        initialFocus={cancelButtonRef}
        onClose={setOpen}
      >
        <div
          className='flex items-end justify-center min-h-screen px-4 pb-20 text-center sm:block sm:p-0'
          dir='rtl'
        >
          <Transition.Child
            as={Fragment}
            enter='ease-out duration-300'
            enterFrom='opacity-0'
            enterTo='opacity-100'
            leave='ease-in duration-200'
            leaveFrom='opacity-100'
            leaveTo='opacity-0'
          >
            <Dialog.Overlay className='fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity' />
          </Transition.Child>

          <span
            className='hidden sm:inline-block sm:align-middle sm:h-screen'
            aria-hidden='true'
          >
            &#8203;
          </span>
          <Transition.Child
            as={Fragment}
            enter='ease-out duration-300'
            enterFrom='opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95'
            enterTo='opacity-100 translate-y-0 sm:scale-100'
            leave='ease-in duration-200'
            leaveFrom='opacity-100 translate-y-0 sm:scale-100'
            leaveTo='opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95'
          >
            <div className='inline-block  bg-white rounded-lg text-center overflow-hidden shadow-xl transform transition-all w-5/12  align-middle max-w-full '>
              <div className='bg-white  pb-4 sm:pb-4 '>
                <div className='  grid grid-rows-3 grid-flow-col max-h-96 text-center'>
                  <div className=' w-full px-4 pt-4 grid grid-rows-3 '>
                    <div className='flex  justify-end'>
                      <button
                        type='button'
                        onClick={() => setOpen(false)}
                        ref={cancelButtonRef}
                      >
                        <FontAwesomeIcon
                          icon={solid('xmark')}
                          size={'2x'}
                          color={'#808080'}
                        />
                      </button>
                    </div>
                    <Dialog.Title
                      as='h3'
                      className='text-lg leading-6 justify-end font-medium text-title-100 text-center align-middle py-1 px-2 w-full'
                    >
                      <p className='flex w-full justify-center  text-title-100'>
                        طلب ارسال رسالة نصية للزبون
                      </p>
                    </Dialog.Title>
                  </div>
                  <div className='mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left row-start-2 row-end-3 '>
                    <div className='mt-2 flex flex-row'>
                      <div className='pr-10 py-2 w-72'>
                        <label
                          htmlFor=''
                          className=' text-title-100 block text-right pb-2'
                        >
                          <span className='text-right'>رقم هاتف الزبون</span>
                        </label>

                        <input
                          type='text'
                          className='w-full  p-2 rounded-md border border-gray-700  focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-100 focus:ring-altaqnya-100 sm:text-sm '
                          placeholder=''
                          value={phoneNumber}
                          readOnly
                        />
                      </div>
                    </div>
                    <div>
                      <div className='px-10 py-6'>
                        <label
                          htmlFor=''
                          className=' text-title-100 block text-right pb-2'
                        >
                          <span className='text-right'>نص الرسالة</span>
                        </label>
                        <textarea
                          rows='4'
                          className='block p-2.5 w-full text-sm text-gray-900  rounded-lg border border-gray-700  focus:ring-blue-500 focus:border-blue-500 '
                          placeholder=''
                          name='notes'
                          value={`${message}`}
                          onChange={(e) => setMessage(e.target.value)}
                        ></textarea>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className=' py-2 sm:px-6 flex  mx-auto justify-center '>
                <button
                  type='button'
                  className='mt-3 w-full  rounded-md border border-gray-300 shadow-sm px-8 py-2  text-base font-medium text-white bg-button-100 hover:bg-altaqnya-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm'
                  onClick={() => blockHandler(false)}
                  ref={cancelButtonRef}
                >
                  ارسال
                </button>
              </div>
            </div>
          </Transition.Child>
          <TailwindToaster />
        </div>
      </Dialog>
    </Transition.Root>
  );
};

export default SubmitModalCustomer;
